import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SparePartSearchSummary,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}parts/search`;

export interface SearchSparePartsQueryArgs {
  sellerId: string;
  manufacturerReference?: string;
  supplierReference?: string;
  sparePartSupplierIds?: string[];
  factoryCode?: string;
  fileSku?: string;
  fileId?: string;
}

export async function searchSparePartsQuery({
  sellerId,
  manufacturerReference,
  supplierReference,
  sparePartSupplierIds,
  factoryCode,
  fileSku,
  fileId,
}: SearchSparePartsQueryArgs): Promise<
  BackResponse<SparePartSearchSummary[]> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<SparePartSearchSummary[]>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        sellerId,
        manufacturerReference,
        supplierReference,
        sparePartSupplierIds,
        factoryCode,
        fileSku,
        fileId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
